import { z } from 'zod';

export const affiliationRequestSchema = z.object({
  id: z.number(),
  message: z.string(),
  contact: z.string().nonempty('O contato é obrigatório.'),
  email: z.string(),
  requestDate: z.string().datetime(),
  pix: z.string().nonempty('A chave pix é obrigatória.'),
  accepted: z.boolean(),
  completed: z.boolean(),
  platformUserId: z.number(),
  platformUserName: z.string(),
  productName: z.string(),
  botConfigId: z.number(),
});
export type AffiliationRequest = z.infer<typeof affiliationRequestSchema>;

export const affiliationRequestToCreateSchema = affiliationRequestSchema.pick({
  pix: true,
  contact: true,
  message: true,
});
export type AffiliationRequestToCreate = z.infer<
  typeof affiliationRequestToCreateSchema
>;

export const affiliationRequestToUpdateSchema = affiliationRequestSchema.pick({
  accepted: true,
});
export type AffiliationRequestToUpdate = z.infer<
  typeof affiliationRequestToUpdateSchema
>;
